/* eslint jsx-a11y/no-autofocus: "off" */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import closeModal, { MODE } from '../actions/message_modal_actions';
import Resources from '../../helpers/resources';

import '../../styles/messageModal.scss';

class MessageModal extends Component {
    constructor(props) {
        super(props);
        this.redirectUrl = window._env_.MatleticaLogin;
    }
    
    buttonHandler = () => {
        window.location.href = this.redirectUrl;
    };
    
    renderContent = (contentType) => {
        const { messageState } = this.props;

        switch (contentType) {
            case 0: // Error message
                return (
                    <div className="modal-message">
                        {messageState.content}
                    </div>
                );
            default:
                return (<div />);
        }
    };
    
    render() {
        const { messageState } = this.props;
        
        if (messageState.mode === MODE.hide) {
            return null;
        }

        return (
            <div className="modal-page">
                <div className="modal-content">
                    {this.renderContent(messageState.contentType)}
                    <div className="modal-image-boy" />
                    <button
                        type="button"
                        className="modal-button"
                        onClick={this.buttonHandler}>
                        Login
                    </button>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        messageState: state.messageState
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        close: closeModal
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MessageModal);
